import {
  toPercentNumber,
  tryTransNumber,
  sentimentNumber,
} from '../../render-helper';

export default [
  { header: 'Hero_Chinese', render: 'name_zh' },
  { header: 'Hero_English', render: 'name_en' },
  { header: 'Mentions', render: 'mentions', renderHelper: [tryTransNumber] },
  {
    header: 'Mentions_ratio',
    render: 'mentions_than',
    renderHelper: [toPercentNumber()],
    numFmt: '0.00%',
  },
  {
    header: 'Non-negative%',
    render: 'non_negative_ratio',
    renderHelper: [toPercentNumber(false)],
    numFmt: '0.00%',
  },
  {
    header: 'Non-negative_ratio',
    render: 'non_negative_ratio_than',
    renderHelper: [toPercentNumber()],
    numFmt: '0.00%',
  },
  {
    header: 'Sentiment',
    render: 'sentiment',
    renderHelper: [sentimentNumber],
    numFmt: ['0.0'],
  },
  {
    header: 'Sentiment_ratio',
    render: 'sentiment_than',
    renderHelper: [toPercentNumber()],
    numFmt: '0.00%',
  },
  {
    header: 'Negative',
    render: 'negative_mentions',
    renderHelper: [tryTransNumber],
  },
  {
    header: 'Negative_ratio',
    render: 'negative_mentions_than',
    renderHelper: [toPercentNumber()],
    numFmt: '0.00%',
  },
  {
    header: 'Global Hero Summary',
    render: 'global_gpt_summary',
  },
  {
    header: 'SEA Hero Summary',
    render: 'sea_gpt_summary',
  },
  {
    header: 'Keywords_Original',
    width: 30,
  },
  {
    header: 'Keywords_Chinese',
    width: 30,
  },
  {
    header: 'Keywords_English',
    width: 30,
  },
];
